import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Input, Select } from 'antd';
import { Button } from '@cropler/ui-kit';
import styles from '../Panel/styles.module.scss';

import { membershipsApi, useAddWorkspaceMembersMutation } from '../../store/api/memberships';
import { getRoles } from '../../utils/ui';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

const MembersPanel = ({ t, setActiveAddPanel }) => {
  const Roles = getRoles(t);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { currentWorkspaceId } = useSelector((state) => state.workspaces);
  const { currentUserRole } = useSelector((state) => state.auth);

  const [addMembers, { isSuccess }] = useAddWorkspaceMembersMutation();

  let roles;
  if (currentUserRole === 'dealer') {
    roles = Roles.filter((item) => item.value === 'viewer');
  } else {
    roles = Roles.filter((item) => item.value !== 'owner');
  }

  const onInvite = () => {
    const email = form.getFieldValue('memberEmail');
    const role = form.getFieldValue('memberRole');

    if (email && role) {
      addMembers({ id: currentWorkspaceId, members: [{ email, role }] })
        .unwrap()
        .catch((errors) => {
          console.log('Some emails are not valid', errors);
        });
    }
  };

  useEffect(() => {
    if (isSuccess) {
      dispatch(membershipsApi.util.resetApiState());
      setActiveAddPanel(false);
    }
  }, [isSuccess]);

  return (
    <Form className={styles.panelForm} form={form} layout="vertical" requiredMark={false}>
      <div>
        <Form.Item
          label="Email"
          name="memberEmail"
          rules={[
            {
              required: true,
              type: 'email',
              message: t('forms.validation.emailInvalid'),
            },
          ]}
        >
          <Input prefix={<CroplerIcon name="email" />} placeholder="example@mail.com" type="email" size={'large'} />
        </Form.Item>
        <Form.Item initialValue={'viewer'} label={t('labels.role')} name="memberRole">
          <Select suffixIcon={<CroplerIcon name="down" />} size={'large'}>
            {roles.map((item) => (
              <Select.Option key={item.value} value={item.value}>
                {item.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </div>

      <Button className={styles.panelButton} type="primary" htmlType="submit" size={'large'} onClick={() => onInvite()}>
        {t('actions.invite')}
      </Button>
    </Form>
  );
};

export default MembersPanel;
